const STORAGE_KEY_DATA = 'viewedProductsData';

function getProductsData() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY_DATA) || '[]');
  } catch {
    return [];
  }
}

function formatPrice(cents) {
  const format = (window.Shopify && window.Shopify.moneyFormat) || '£{{amount}}';
  // Round to the nearest whole currency unit — no decimals shown.
  const whole = Math.round(Number(cents || 0) / 100);
  return format.replace('{{amount}}', String(whole)).replace('{{amount_no_decimals}}', whole);
}

function renderProductCard(product) {
  const compareAtPriceHtml = product.compare_at_price
    ? `<span style="text-decoration: line-through;" class="money text-sm text-gray-400 block">${formatPrice(product.compare_at_price)}</span>`
    : '';

  const priceColor = product.compare_at_price ? 'color:#FF3C3C;' : '';

  return `
    <li class="collection-item js-collection-item pb-6">
      <div class="text-center relative" style="display:flex;flex-direction:column;height:100%;">
        <a href="${product.url}" aria-label="${product.title}" class="block">
          <div class="aspect-h-4 aspect-w-3 block transition-opacity duration-300 hover:opacity-50 mb-4 sm:mb-8"
               style="position:relative;aspect-ratio:3/4;overflow:hidden;">
            <img src="${product.image}" alt="${product.title}"
                 style="width:100%;height:100%;object-fit:cover;" loading="lazy">
          </div>
          <div class="grid-view-item__vendor text-sm sm:text-base font-medium uppercase tracking-widest mb-3 sm:mb-4">
            ${product.vendor || ''}
          </div>
          <div class="grid-view-item__title text-xs sm:text-sm max-w-xs mb-0 mx-auto h-12 sm:h-16 line-clamp-3">
            ${product.title}
          </div>
          <div class="mt-3">
            ${compareAtPriceHtml}
            <div class="text-lg sm:text-xl font-serif collection-item__price" style="${priceColor}">
              ${formatPrice(product.price)}
            </div>
          </div>
        </a>
      </div>
    </li>`;
}

function initRecentlyViewed() {
  const sections = document.querySelectorAll('[data-recently-viewed-section]');
  if (!sections.length) return;

  const allProducts = getProductsData();
  if (!allProducts.length) return;

  sections.forEach((section) => {
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const maxProducts = parseInt(grid.dataset.maxProducts || '4', 10);
    const currentProductId = section.dataset.currentProductId || '';

    const products = allProducts
      .filter((p) => String(p.id) !== String(currentProductId))
      .slice(0, maxProducts);

    if (!products.length) return;

    grid.innerHTML = products.map(renderProductCard).join('');
    section.style.display = '';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
} else {
  initRecentlyViewed();
}
